/* USER ACTIONS KEY */
export const USER_UPDATE = "USER_UPDATE";
export const USER_LOAD_ERROR = "USER_LOAD_ERROR";
/* MODAL ACTIONS KEY */
export const MODAL_OPEN = "MODAL_OPEN";
export const MODAL_CLOSE = "MODAL_CLOSE";
/* PAGE ERROR ACTIONS KEY */
export const PAGE_ERROR_OPEN = "PAGE_ERROR_OPEN";
export const PAGE_ERROR_CLOSE = "PAGE_ERROR_CLOSE";
